module.exports = __webpack_public_path__ + "assets/img/teacher (43).2cce6c39.png";